import { Component, OnInit } from '@angular/core';
import { ShoppingService } from '../../core/services/shopping.service';
import { OrderSummaryModel } from '../../core/models/OrderSummary.model';
import { CartItemsModel } from '../../core/models/ShoppingCart.model';
import { HelperService } from '../../core/services/helper.service';
import { appVariables } from '../../core/constants/Common.constant';
import { matTooltipAnimations, MatTooltip, MatTooltipModule, MatButton } from '@angular/material';
import { Observable } from '../../../../node_modules/rxjs/Observable';

@Component({
  selector: 'app-order-summary',
  templateUrl: './order-summary.component.html',
  styleUrls: ['./order-summary.component.css']
})
export class OrderSummaryComponent implements OnInit {
  CartItemsList: CartItemsModel[];
  OrderSummary: OrderSummaryModel;
  DisplaySection = appVariables.displaySectionValues;
  hasDiscount=false;
  promoCodeDiscountValue :any;
  promoCodeAmountValue :any;
  constructor(private shoppingService: ShoppingService, private helperService: HelperService) {
    this.OrderSummary = new OrderSummaryModel();
  }


  ngOnInit() { 
    //document.getElementsByTagName('body')[0].appendChild(this.shoppingService.LoadGoogleAnalyticScripts());
    this.shoppingService.IsValidPromoCodeApplied.subscribe(isValid => {
        this.OrderSummary.PromoCode = this.helperService.getFromLocalStorage(appVariables.promoCode);
  });
    this.shoppingService.observeDisplaySection.subscribe(response => {
    //  debugger;
      this.DisplaySection = response;
      this.OnClickChangeOrderSummery();
    });
    this.OrderSummary.PromoCode = this.helperService.getFromLocalStorage(appVariables.promoCode);
    this.shoppingService.observeCartItems.subscribe(cartItemsList => {
     // debugger;
      this.CartItemsList = cartItemsList;
      this.OrderSummary = new OrderSummaryModel();
      this.OrderSummary.PromoCode = this.helperService.getFromLocalStorage(appVariables.promoCode);
      if (this.CartItemsList.length !== 0 && this.CartItemsList[0].CartSubtotal !== '') {
        this.hasDiscount = this.CartItemsList.some(ci => ci.DiscountPercent !== '' && this.OrderSummary.PromoCode !== '')
        this.promoCodeDiscountValue = this.CartItemsList.find(ci => Number(ci.DiscountPercent) !== 0) ? this.CartItemsList.find(ci => Number(ci.DiscountPercent) !== 0).DiscountPercent : 0;
        this.promoCodeAmountValue = this.CartItemsList.find(a=>a.PromoCodeAmount != null)? this.CartItemsList.find(a=>a.PromoCodeAmount != null).PromoCodeAmount : "";
        if(this.DisplaySection.Payment){
          this.OrderSummary.Total = Number(this.CartItemsList[0].CartSubtotal.replace(',', ''))
          + Number(this.CartItemsList[0].TaxAmount) + Number(this.CartItemsList[0].ShippingCharge);
          this.OrderSummary.PromoCodeDiscount = Number(this.promoCodeDiscountValue);
          this.OrderSummary.PromoCodeAmount = Number(this.promoCodeAmountValue);
          this.OrderSummary.Shipping = Number(this.CartItemsList[0].ShippingCharge);
          this.OrderSummary.TaxAmount = Number(this.CartItemsList[0].TaxAmount);
        }
        else{
          this.OrderSummary.Total = Number(this.CartItemsList[0].CartSubtotal.replace(',', ''))
          + Number(this.CartItemsList[0].ShippingCharge);
          this.OrderSummary.PromoCodeDiscount = Number(this.promoCodeDiscountValue);
          this.OrderSummary.PromoCodeAmount = Number(this.promoCodeAmountValue);
          this.OrderSummary.Shipping = Number(this.CartItemsList[0].ShippingCharge);
        }
      }
      for (let i = 0; i < cartItemsList.length; i++) {
        this.OrderSummary.SubTotal += Number(cartItemsList[i].ListPrice * cartItemsList[i].Quantity);
      }
      this.OrderSummary.SubTotal = Number((this.OrderSummary.SubTotal).toFixed(2));
    });
  }


  OnClickChangeOrderSummery(){
   // debugger;
    this.OrderSummary.PromoCode = this.helperService.getFromLocalStorage(appVariables.promoCode);
    this.shoppingService.observeCartItems.subscribe(cartItemsList => {
     // debugger;
      this.CartItemsList = cartItemsList;
      this.OrderSummary = new OrderSummaryModel();
      this.OrderSummary.PromoCode = this.helperService.getFromLocalStorage(appVariables.promoCode);
      if (this.CartItemsList.length !== 0 && this.CartItemsList[0].CartSubtotal !== '') {
         this.hasDiscount = this.CartItemsList.some(ci => ci.DiscountPercent !== '' && this.OrderSummary.PromoCode !== '')
        this.promoCodeDiscountValue = this.CartItemsList.find(ci => Number(ci.DiscountPercent) !== 0) ? this.CartItemsList.find(ci => Number(ci.DiscountPercent) !== 0).DiscountPercent : 0;
        this.promoCodeAmountValue = this.CartItemsList.find(a=>a.PromoCodeAmount != null)? this.CartItemsList.find(a=>a.PromoCodeAmount != null).PromoCodeAmount : "";
        if(this.DisplaySection.Payment){
          this.OrderSummary.Total = Number(this.CartItemsList[0].CartSubtotal.replace(',', ''))
          + Number(this.CartItemsList[0].TaxAmount) + Number(this.CartItemsList[0].ShippingCharge);
          this.OrderSummary.PromoCodeDiscount = Number(this.CartItemsList[0].DiscountPercent);
          this.OrderSummary.PromoCodeAmount = Number(this.CartItemsList[0].PromoCodeAmount);
          this.OrderSummary.Shipping = Number(this.CartItemsList[0].ShippingCharge);
          this.OrderSummary.TaxAmount = Number(this.CartItemsList[0].TaxAmount);
        }
        else{
          this.OrderSummary.Total = Number(this.CartItemsList[0].CartSubtotal.replace(',', ''))
          + Number(this.CartItemsList[0].ShippingCharge);
          this.OrderSummary.PromoCodeDiscount = Number(this.CartItemsList[0].DiscountPercent);
          this.OrderSummary.PromoCodeAmount = Number(this.CartItemsList[0].PromoCodeAmount);
          this.OrderSummary.Shipping = Number(this.CartItemsList[0].ShippingCharge);
        }
      }
      for (let i = 0; i < cartItemsList.length; i++) {
        this.OrderSummary.SubTotal += Number(cartItemsList[i].ListPrice * cartItemsList[i].Quantity);
      }
      this.OrderSummary.SubTotal = Number((this.OrderSummary.SubTotal).toFixed(2));
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/shoppingcart/order-summary/order-summary.component.ts